import { applySnapshot, types } from "mobx-state-tree";
import { IInput } from "../../utils/common-interface";
import customtypes from "../../utils/mobx-types-helper";

export const ComposeChartModel = types
    .model("ComposeChartModel", {
        name: customtypes.optional(types.string, ""),
        a: customtypes.optional(types.number, 0),
        b: customtypes.optional(types.number, 0),
        c: customtypes.optional(types.number, 0),
        d: customtypes.optional(types.number, 0),
        e: customtypes.optional(types.number, 0),
        f: customtypes.optional(types.number, 0),
        g: customtypes.optional(types.number, 0),
        gdp: customtypes.optional(types.number, 0),
    })
    .views((self: any) => ({
        //
    }))
    .actions((self: any) => ({
        setField: ({ fieldname, value }: IInput) => {
            self[fieldname] = value;
        },
        resetAll: () => {
            applySnapshot(self, {});
        },
    }));
export type IComposeChartModel = typeof ComposeChartModel.Type;
